import { Card } from '@/components/ui/card';
import { Zap, DollarSign, Sliders, CreditCard, Clock, Shield } from 'lucide-react';

const advantages = [
  {
    icon: Zap,
    title: 'Ultra-Fast Execution',
    description: 'Execute trades with speed and confidence.',
  },
  {
    icon: DollarSign,
    title: 'Competitive Spreads',
    description: 'Cost-efficient trading with tight spreads.',
  },
  {
    icon: Sliders,
    title: 'Flexible Leverage',
    description: 'Choose the trading power that fits your strategy.',
    note: '*Subject to terms and compliance guidelines.',
  },
  {
    icon: CreditCard,
    title: 'Easy Transactions',
    description: 'Simple funding and withdrawal processes.',
  },
  {
    icon: Clock,
    title: '24/7 Multilingual Support',
    description: 'Get help whenever you need it.',
  },
  {
    icon: Shield,
    title: 'LICENSED JURISDICTION',
    description: 'Licensed in Saint Lucia.',
  },
];

export const AdvantagesSection = () => {
  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3">
            Our Advantages
          </h2>
          <p className="text-lg text-gray-600">
            Enjoy a trading journey designed to be customer-centric and accessible.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {advantages.map((advantage, index) => (
            <Card key={index} className="p-6 hover:shadow-lg transition-all duration-300 border-gray-200 bg-white">
              <div className="w-12 h-12 bg-primary/10 rounded-xl flex items-center justify-center mb-4">
                <advantage.icon className="h-6 w-6 text-primary" />
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">{advantage.title}</h3>
              <p className="text-gray-600 text-sm leading-relaxed mb-2">{advantage.description}</p>
              {advantage.note && (
                <p className="text-xs text-gray-500 italic">{advantage.note}</p>
              )}
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AdvantagesSection;